// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import { getDongleHardware, getDongleReports, IDongleReportQueryParams } from '../api/dongle'
import { message } from 'antd'

export type dongleState = {
  dongleReport: any[]
  dongleHardware: any[]
}
export const dongleDevices = {
  state: {
    dongleReports: [],
    dongleHardwareInfos: [],
    dongleDeviceID: "GD0112020002001"
  },

  reducers: {
    updateDongleReports: (state, dongleReports) => ({ ...state, dongleReports }),
    updateDongleHardware: (state, dongleHardwareInfos) => ({ ...state, dongleHardwareInfos }),
    clear () {
      return {
        dongleReports: [],
        dongleHardware: [],
      }
    }
  },

  effects: dispatch => ({
    async fetchDongleReports (query, rootState) {
      let res
      try {
        res = await getDongleReports(query)
        const deviceReports = res.device_reports.map(item =>({
          ...item,
          lat: item.latitude,
          lon: item.longitude,
          deviceID: item.device_id
        }))
        this.updateDongleReports(deviceReports)
      } catch (e) {
        message.error('fetch dongle reports Error:' + e.message)
        return
      }
    },
    async fetchDongleHardware (query, rootState) {
      let res
      try {
        res = await getDongleHardware(query)
        this.updateDongleHardware(res.hardware_infos || [])
      } catch (e) {
        message.error('fetch dongle hardware info Error:' + e.message)
        return
      }
    }
  })
}
